export default __webpack_public_path__ + "static/media/waterfall_300.45889b06.webp";